import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'scanType';

export class ScanType extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
